import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles({
  container: {
    minHeight: '100vh',
  },
})
